<template>
  <el-dialog title="选择供应商" :visible.sync="visibleInner" width="800px" append-to-body @close="$emit('update:visible', false)">
    <el-form :inline="true">
      <el-form-item label="编码"><el-input v-model="code" size="small" clearable /></el-form-item>
      <el-form-item label="名称"><el-input v-model="name" size="small" clearable /></el-form-item>
      <el-form-item><el-button size="small" type="primary" @click="pageIndex = 1; load()">查询</el-button></el-form-item>
    </el-form>
    <el-table :data="list" border height="360" v-loading="loading">
      <el-table-column prop="supplierCode" label="供应商编码" width="140" />
      <el-table-column prop="supplierName" label="供应商名称" min-width="180" />
      <el-table-column prop="phone" label="电话" width="130" />
      <el-table-column label="操作" width="80" align="center">
        <template slot-scope="scope">
          <el-button type="text" @click="choose(scope.row)">选择</el-button>
        </template>
      </el-table-column>
    </el-table>
  </el-dialog>
</template>

<script>
import { docList } from '../api/erp/doc'

export default {
  name: 'SupplierSelector',
  props: { visible: Boolean },
  data() {
    return { visibleInner: false, code: '', name: '', list: [], loading: false, pageIndex: 1 }
  },
  watch: {
    visible: {
      immediate: true,
      handler(val) {
        this.visibleInner = !!val
        if (val) this.load()
      }
    }
  },
  methods: {
    load() {
      this.loading = true
      docList('/purchase/supplier', { pageIndex: this.pageIndex, pageSize: 20, code: this.code, partnerName: this.name, status: '0' })
        .then(res => {
          this.list = (res.data && res.data.list) || []
        }).finally(() => { this.loading = false })
    },
    choose(row) {
      this.$emit('select', row)
      this.$emit('update:visible', false)
    }
  }
}
</script>
